module.exports = __webpack_public_path__ + "img/Weilin visual capacitance positive and negative detection software.0e2cafb7.jpg";